<template>
  <div class="comp-list-view lecto-favorite" v-loading="loading == -1">
    <div class="comp-list-con-div">
      <div class="comp-list-con">
        <el-table
          :data="dataList"
          size="mini"
          empty-text="暂无数据"
          style="width: 100%">
          <el-table-column
            label="移动目录"
            align="center"
            width="70">
            <template slot-scope="scope">
              <el-button type="text" size="small" class="drag-edit">
                <i class="drag-edit" title="可拖拽放置指定的目录中"><svg-drag :width="18" :height="18" fill="#606266"></svg-drag></i>
              </el-button>
            </template>
          </el-table-column>
          <el-table-column
            label="序号"
            align="center"
            width="50px"
            type="index">
          </el-table-column>
          <el-table-column label="我的零配件">
            <template slot-scope="scope">
              <p class="table-name remark" v-if="scope.row.Remark">{{scope.row.Remark}}</p>
              <p class="table-name">
                {{scope.row.NationalMark ? `[${scope.row.NationalMark}]` : ''}}
                {{scope.row.FileName}}
                {{getMaterials(scope.row.LectoParams)}}
              </p>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" prop="CreateDate" width="140" align="center"></el-table-column>
          <el-table-column
            label="操作"
            width="150"
            align="center">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="_dataUpdate(scope.row)" v-if="isCanEdit">{{scope.row.Remark ? '修改' : '设置'}}别名</el-button>
              <el-button type="text" size="small" @click="_skuDetail(scope.row)">查看</el-button>
              <el-button type="text" size="small" @click="_dataDelete(scope.row)" v-if="isCanEdit">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div class="pagination">
      <md-page :page="page" :total="total" :pageSize="pageSize" @pagecallback="pageChanged"></md-page>
    </div>
  </div>
</template>

<script>
import {MessageBox,Message} from 'element-ui'
import {Category} from "@digital-supply-chain/module";
//引入服务
import {CommonService, DragService,RespurceService,OpenService,FavoriteService,UserService} from "@/service";

import SvgDrag from '@/components/svg/drag.vue';
import MdPage from '@/components/md-page.vue';

export default{
  components: { SvgDrag, MdPage },
  props: {
    dirId: { default: 0 },
    listType: { default: '' },
    cateParents: { default: [] },
  },
  watch: {
    dirId (value) {
      this.lectoDirId = value;
      this.listType.includes('LectoFavorite') && (this.loadList(true));
    }
  },
  data() {
    return {
      lectoDirId: 0,
      dataList: [],
      loading: 0, //状态  -1加载中 0 未加载  1 加载完成
      page: 1,
      pageSize: 20,
      total: 0,
    }
  },
  computed: {
    // 是否可编辑
    isCanEdit() {
      if (this.listType != 'LectoFavoriteDirShare') {
        return true;
      }
      return UserService.user().IsManager;
    }
  },
  methods: {
    getMaterials(LectoParams = []) {
      const materials = LectoParams.find(item => item.ItemName.includes('材料'));
      return materials ? `[${materials.ItemValue}]` : '';
    },

    async loadList(isFirst = false) {
      //加载产品列表
      this.loading = -1;
      isFirst && (this.page = 1)
      
      const res = await RespurceService.getResListByCategoryId(
        Category[this.listType],
        Category.Outsourcing,
        this.lectoDirId,
        this.page,
        this.pageSize,
        this.cateParents[0] && this.cateParents[0].TreeID == 'list_-1' ? true : false,
      );
      this.loading = 1;
      if (res.code === 0) {
        this.dataList = res.data.list.map(item => {
          let Params = {};
          try {
            Params = JSON.parse(item.Params);
          } catch (error) {}
          return {
            DirID: this.lectoDirId,
            ...item,
            ...Params,
          }
        });
        this.total = res.data.count;
      }
      this.initDrag();
    },

    pageChanged(param) {
      this.page = param.page;
      this.loadList();
    },

    _dataDelete(value) {
      MessageBox.confirm('确定删除吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await CommonService.dataDelete(Category[this.listType], Category.Outsourcing, this.lectoDirId, value.ID);
        this.$parent.dragDataCallback(0, Category[this.listType], this.lectoDirId, Category[this.listType]);
        this.loadList();
      })
    },

    async _dataUpdate(itemValue) {
      MessageBox.prompt('请输入别名', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: itemValue.Remark || itemValue.FileName,
      }).then(({ value }) => {
        FavoriteService.updateModelParamsExists(itemValue.ID, {
          Remark: value || '',
        }).then((res) => {
          if (res.code === 0) {
            Message.success('操作成功')
            this.loadList();
          }
        })
      })
    },

    _skuDetail(value) {
      const LectoParamsObj = value.LectoParams.map(item => ({
        name: item.ItemName,
        value: item.ItemValue,
        id: item.ItemID,
      }))
      const lecto_params = encodeURIComponent(JSON.stringify(LectoParamsObj));
      OpenService.openProdDetails(value.ProdID, lecto_params || '');
    },

    initDrag() {
      this.$nextTick(() => {
        DragService.dragToTree({
          table: document.getElementsByClassName('lecto-favorite')[0],
          wrapper: 'tbody',
          handle: ".drag-edit",
          delay: 1,
          primaryKey: "ID",
          datas: this.dataList,
          category: Category.Outsourcing,
          callback: this.dragCallback,
          dirCategory: Category.LectoFavoriteDir,
          operateAreaId: [Category.LectoFavoriteDir, Category.LectoFavoriteDirShare],
          
        })
      })
    },

    dragCallback(args = {}) {
      this.loadList();
      this.$parent.dragDataCallback(args.treeId, args.treeDirCategoryId, this.dirId, args.dirCategoryId, args.copy);
    },
  },
}
</script>

<style lang="less" scope>
.table-name{
  margin: 0;
  font-size: 14px;
  &.remark{
    font-size: 14px;
    font-weight: bold;
  }
}
.comp-list-view{
  display: flex;
  /deep/ .el-empty{
    flex: 1;
  }
  /deep/ th{
    padding: 2px 0;
    color: #409EFF;
  }
}
.comp-list-con-div{
  flex: 1;
  height: calc(100vh - 20px - 43px);
  overflow-y: auto;
  padding-bottom: 40px;
}
.comp-list-con{
  display: flex;
  flex-wrap: wrap;
  padding: 0 5px 10px 5px;
  flex: 1;
}
.edit-view{
  position: absolute;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  opacity: 0;
  transform: translateY(26px);
  transition: all 0.4s;
  i{
    width: 26px;
    height: 26px;
    color: #fff;
    font-size: 18px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .exist-span{
    width: 120px;
    height: 26px;
    color: #fff;
    font-size: 13px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .drag-edit{
    cursor: move;
  }
}
.comp-list-con{
  /deep/ .list-card:hover .edit-view{
    opacity: 1;
    transform: translateY(0px);
  }
}
.pagination{
  position: absolute;
  left: 0;
  width: 100%;
  bottom: 0;
}
</style>
